import { timezones } from './config/time-zones'
import { DAY_LIST } from './config/day-list'

export const timeZones = () => {
  return Object.entries(timezones).map(([text, value]) => ({ text, value }))
}

export const dayList = () => {
  return DAY_LIST.map((text) => ({ text, value: text.substring(0, 3) }))
}
